<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Init',
  props: {},
  data() {
    return {}
  },
  created() {
    this.$emit('init')
  },
}
</script>